import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import { SchedulingRoutingModule } from './scheduling-routing.module';
import { InventoryModule } from '../inventory/inventory.module';

import { SchedulingComponent } from './scheduling.component';
import { SchedulerComponent } from './scheduler/scheduler.component';
import { AimsSchedulerComponent } from './aims-scheduler/aims-scheduler.component';
import { AimsSchedulerCalendarViewComponent } from './aims-scheduler/aims-scheduler-calendarview.component';
import { AimsSchedulerDetailViewComponent } from './aims-scheduler/aims-scheduler-detailview.component';
import { AimsSchedulerGanttComponent } from './aims-scheduler/aims-scheduler-gantt.component';
import { SchConfigComponent } from './sch-config/sch-config.component';
import { AimsScheduleItemEditorComponent } from './aims-scheduler/aims-schedule-item-editor/aims-schedule-item-editor.component';
import { TravelRequestComponent } from './travel-request/travel-request.component';
import { SanComponent } from './san/san.component';
import { TravelDashboardComponent } from './travel-request/travel-dashboard/travel-dashboard.component';
import { TravelOrphanedComponent } from './travel-request/travel-orphaned/travel-orphaned.component';
import { TravelOpenendedComponent } from './travel-request/travel-openended/travel-openended.component';
import { TravelAwaitingComponent } from './travel-request/travel-awaiting/travel-awaiting.component';
import { SchedulerActionRequiredComponent } from './scheduler-action-required/scheduler-action-required.component';
import { TravelApprovalComponent } from './travel-request/travel-approval/travel-approval.component';
import { ScheduleApprovalComponent } from './schedule-approval/schedule-approval.component';
import { TravelUnconfirmedComponent } from './travel-request/travel-unconfirmed/travel-unconfirmed.component';
//import { ScheduleItemComponent } from './schedule-item/schedule-item.component';
import { ColorHueModule } from 'ngx-color/hue'; // <color-hue-picker></color-hue-picker>
import { ColorCompactModule } from 'ngx-color/compact'; // <color-compact></color-compact>

@NgModule({
  imports: [
    SharedModule,
    SchedulingRoutingModule,
    InventoryModule,
    ColorCompactModule,
    ColorHueModule
  ],
  declarations: [
    SchedulingComponent,
    SchedulerComponent,
    AimsSchedulerComponent,
    AimsSchedulerCalendarViewComponent,
    AimsSchedulerDetailViewComponent,
    AimsSchedulerGanttComponent,
    SchConfigComponent,
    AimsScheduleItemEditorComponent,
    TravelRequestComponent,
    SanComponent,
    TravelDashboardComponent,
    TravelOrphanedComponent,
    TravelOpenendedComponent,
    TravelAwaitingComponent,
    SchedulerActionRequiredComponent,
    TravelApprovalComponent,
    ScheduleApprovalComponent,
    TravelUnconfirmedComponent,
    //ScheduleItemComponent
  ]
})
export class SchedulingModule { }
